import { FC, PropsWithChildren } from "react";

interface TabPanelProps extends PropsWithChildren {
  index: any;
  value: any;
  marginBottom?: boolean;
}

export const TabPanel: FC<TabPanelProps> = (props) => {
  const { marginBottom = true, children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      style={marginBottom ? { marginBottom: "145px" } : {}}
      {...other}
    >
      {value === index && children}
    </div>
  );
};
